// extracted by mini-css-extract-plugin
export default {"container":"container_container__lhQY3","content":"container_content__qGR8d"};